import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Input from '../shared/Input';
import SelectDropdown from '../shared/SelectDropdown'
import { fetchData, fetchFormData, getValueLabel } from '../../utils/options';
import topTost from '../../utils/topTost';


const CityCreate = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [stateData, setStateData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [formData, setFormData] = useState({
        state: "",
        district: '',
        city: '',
    });

    const fetchAllData = async () => {
        const stateData = await fetchData("active-states");

        // Handle State Data
        if (stateData) {
            const states = stateData.states;
            setStateData(getValueLabel(states, "state_title", "state_id") || []);
        }

    };

    const fetchDistrictData = async (stateId) => {
        const result = await fetchData(`districts/${stateId}`, {}, "POST");

        if (result) {
            const districts = result.districts;
            setDistrictData(getValueLabel(districts, "district_title", 'district_id') || []);
        }
    };

    const handleCityChange = (name, value) => {
        if (value === undefined) {
            console.error(`Value for ${name} is undefined`);
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };


    const handleStateChange = (option) => {
        setFormData((prevData) => ({
            ...prevData,
            state: option.value,
            district: '',
            city: '',
        }));
        setDistrictData([]);
        fetchDistrictData(option.value);
    };

    const handleDistrictChange = (option) => {
        setFormData((prevData) => ({
            ...prevData,
            district: option.value,
            city: '',
        }));
    };

    const fetchDetails = async (id) => {
        try {
            const result = await fetchData(`city/details/${id}`, {}, 'POST');

            if (result && result.city) {
                setFormData((prevData) => ({
                    ...prevData,
                    state: result.city.state_id,
                    district: result.city.district_id,
                    city: result.city.city_title,
                }));
                fetchDistrictData(result.city.state_id)
            } else {
                console.warn('data not found.');
                setFormData([]);
            }
        } catch (error) {
            console.error('Failed to fetch user details:', error);
            setFormData([]);
        }
    };

    useEffect(() => {
        fetchAllData();
        if (id) {

            fetchDetails(id);
        }
    }, [id]);


    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const formPayload = new FormData();
        formPayload.append("city_title", formData.city);
        formPayload.append("state_id", formData.state);
        formPayload.append("district_id", formData.district);
        formPayload.append("description", formData.city);
        formPayload.append("status", 1);

        try {
            let res;

            if (id) {
                // Edit logic
                formPayload.append("city_id", id);
                res = await fetchFormData(`update-city`, formPayload, "POST");
                console.log("Updating city:", id, formData);
            } else {
                // Add logic
                res = await fetchFormData("add-city", formPayload, "POST");
                console.log("Creating new city:", formData);
            }

            if (res && res.code === 200) {
                navigate("/master/city-list");
                topTost({
                    title: res.message,
                    icon: "success",
                });
            } else {
                console.error("City operation failed", res);
            }
        } catch (error) {
            console.error("Submit error:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>

            <div className="col-lg-12">
                <div className="card stretch stretch-full">
                    <hr className="mt-0" />
                    <div className="card-body general-info">
                        <div className="mb-5 d-flex align-items-center justify-content-between">
                            <h5 className="fw-bold mb-0 me-4">
                                <span className="d-block mb-2">{id ? 'Edit City:' : 'Add City:'}</span>
                            </h5>
                        </div>

                        <form onSubmit={handleSubmit} className="row g-3">
                            <div className="row mb-4">
                                {/* State */}
                                <div className="col-lg-2">
                                    <label className="fw-semibold">State:
                                      <span className="text-danger">*</span>
                                    </label>
                                </div>
                                <div className="col-lg-4">
                                    <SelectDropdown
                                        options={stateData}
                                        value={Number(formData.state)}
                                        selectedOption={stateData.find(opt => opt.value === Number(formData.state)) || null}
                                        defaultSelect="Select State"
                                        onSelectOption={handleStateChange}
                                        icon="feather-map-pin"
                                    />
                                </div>

                                <div className="col-lg-2">
                                    <label className="fw-semibold">District: </label>
                                </div>
                                <div className="col-lg-4">
                                    <SelectDropdown
                                        options={districtData}
                                        value={Number(formData.district)}
                                        selectedOption={districtData.find(opt => opt.value === Number(formData.district)) || null}
                                        defaultSelect={"Select District"}
                                        onSelectOption={handleDistrictChange}
                                        icon="feather-layers"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className='col-md-6'>
                                    <Input
                                        icon='feather-map-pin'
                                        label={"City"}
                                        labelId={"cityInput"}
                                        placeholder={"City"}
                                        name={"city"}
                                        value={formData.city || ''}
                                        onChange={handleCityChange}
                                    />
                                </div>
                            </div>
                            <div className="mt-5 customButton">
                                <button type="submit" className="btn btn-lg btn-primary" disabled={isSubmitting}>
                                    {isSubmitting ? 'Submitting...' : id ? 'Update' : 'Submit'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CityCreate;
